import TravelExploreOutlinedIcon from '@mui/icons-material/TravelExploreOutlined';
import DetectiveDetailBody from '../DetectiveDetailBody';

// Descriptor for the Detective engine — the 5th detection engine and the 6th
// Security Hub capability (AWS Config is a capability but deliberately not an
// engine, so the two counts differ by one). Same shape as cspm.js /
// guardduty.js / macie.js / inspector.js; registering it in registry.js
// auto-wires the sidebar, Overview tiles, the EnableCapabilities panel,
// Configuration → Regions and the unified findings inbox.
export const detectiveEngine = {
  id: 'detective', // MUST equal the backend Engine.ID()
  label: 'Amazon Detective',
  // Indigo, chosen to stay distinguishable from the four accents already in use
  // — CSPM light blue, GuardDuty orange, Macie teal, Inspector purple — and from
  // severity.js's CRITICAL red. The hex is duplicated as a local const in every
  // Detective page; that duplication is the established convention here, not an
  // oversight.
  color: '#3949AB',
  Icon: TravelExploreOutlinedIcon,
  // DEAD DATA: EnableCapabilities reads the capability copy off the API response
  // (row.capability), never off this object. The user-visible copy lives in Go,
  // in securityhub_engine_detective.go's Capability(); this block is kept only
  // for shape-parity with the sibling descriptors, and is transcribed verbatim
  // from that Go source so the two cannot disagree if it ever is wired up.
  // NOTE: the card's copy (name/source/description/items) is served by the
  // BACKEND — EnableCapabilities reads `row.capability` from /capabilities and
  // falls back to `{}`, never to this file. A duplicate here was already drifting
  // from Go's Capability() on at least one engine, so it was removed rather than
  // left to be trusted. Change the copy in securityhub_engine_<id>.go.
  // Sidebar sub-items. They hang directly off the SECURITY HUB group —
  // there is no "Detection engines" grouping in PortalSidebar.
  // Routes are NOT generated from this list — every entry needs a matching
  // <Route> in App.js or it falls through to the catch-all redirect, which looks
  // like the page does not exist rather than like a missing route.
  nav: [
    { label: 'Investigations', to: '/securityhub/detective' },
    { label: 'Findings', to: '/securityhub/detective/findings' },
    { label: 'Enrollment', to: '/securityhub/detective/enrollment' },
    { label: 'Settings', to: '/securityhub/detective/settings' },
  ],
  enableRoute: '/securityhub/detective', // where "Enable/Configure" routes
  DetailBody: DetectiveDetailBody,
};
